// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
export var ACTIVATE_EXPERIMENT = 'ACTIVATE_EXPERIMENT';
export var ADD_EXPERIMENT = 'ADD_EXPERIMENT';
export var DEACTIVATE_EXPERIMENT = 'DEACTIVATE_EXPERIMENT';
export var LOAD_EXPERIMENT = 'LOAD_EXPERIMENT';
export var EEE_REPORTED = 'EEE_REPORTED';
export * from '../shared/actions/impressions';
export var activateExperiment = function activateExperiment(experimentID) {
  return {
    type: ACTIVATE_EXPERIMENT,
    experimentID: experimentID
  };
};
export var eeeReported = function eeeReported(experimentID) {
  return {
    type: EEE_REPORTED,
    experimentID: experimentID
  };
};
export var deactivateExperiment = function deactivateExperiment(experimentID) {
  return {
    type: DEACTIVATE_EXPERIMENT,
    experimentID: experimentID
  };
}; // Load experiment action creator can be exposed to the window for Optimizely to utilize

export var loadExperiment = function loadExperiment(experimentID, variantName) {
  return {
    type: LOAD_EXPERIMENT,
    experimentID: experimentID,
    variantName: variantName
  };
};
/**
 * Add an experiment that was not fetched via the typical node fetching. Expects an experiment to be
 * formatted as if it was returned from a python service using the python AB SDK, e.g.
 * {
 *      "test_id": null,
 *      "eee_flag": false,
 *      "name": "Control",
 *      "custom_data": {},
 *      "ramp": null,
 *      "test_name": "cool_experiment",
 *      "_id": null
 *  }
 */

export var addExternalExperiment = function addExternalExperiment(variantInfo, external) {
  var variantName = get(variantInfo, 'name', '');

  if (external) {
    return loadExperiment(variantInfo.experimentID, variantName);
  }

  return {
    type: ADD_EXPERIMENT,
    experiment: {
      variantID: get(variantInfo, '_id'),
      variantName: variantName,
      testID: get(variantInfo, 'test_id'),
      testName: get(variantInfo, 'test_name'),
      ramp: get(variantInfo, 'ramp'),
      usesEEE: get(variantInfo, 'eee_flag', false),
      customData: get(variantInfo, 'custom_data', {})
    }
  };
};